import React from "react";
import { Fragment } from "react";
import Links from "../../components/links/Links";

export const TermsPage = () => {
  return (
    <Fragment>
      <div className="faq-container">
        <h1>Terms & Conditions</h1>
        <div className="question-container">
          <div className="question">
            <h5>User’s Terms</h5>
            <p>
              THIS LEGAL USER’S TERM AGREEMENT BETWEEN YOU AND THRILLER GOVERN
              YOUR USE OF THE THRILLER PRODUCTS, SOFTWARE, SERVICES, WEB
              APPLICATION AND WEBSITE. IT IS IMPORTANT THAT YOU READ AND
              UNDERSTAND CAREFULLY BEFORE ORDRING OR USING THE PLATFORM THE
              FOLLOWING TERMS. BY CLICKING "AGREE," YOU ARE AGREEING THAT THESE
              TERMS WILL APPLY IF YOU CHOOSE TO ACCESS OR USE THE SERVICE ON
              THRILLER PLATFORM.
            </p>
          </div>

          <div className="question">
            <h5>GENERAL</h5>
            <p>
              THRILLER provides electronic web-based e-commerce platform and
              offering registered individual person (Seller) certain services
              (the " Services”) to facilitate the marketing, sale their products
              and goods to its Buyer ("Buyer"). Website Thriller.com is
              hereinafter collectively referred to as “Platform”. For the
              purposes of the Terms of Use, “You" shall mean the person who is
              accessing the Platform or “User” (Buyer and Seller as hereinafter
              collectively referred to as “Users”). These are the terms and
              conditions governing your access to and use of the website
              Thriller.com, mobile Application and its related sub-domains,
              website, services, and tools. By accepting these terms and
              conditions and by using the Platform, you represent that you agree
              to comply with these terms with THRILLER in relation to your use
              of the Platform. This User’s Terms is effective upon acceptance.
              If you do not agree to be bound by this User Terms please do not
              access, register with, or use this Platform. Before you may become
              or continue as a member of the Platform, you must read, agree
              with, and accept this User Terms and THRILLER’s Privacy Policy
              (the "Privacy Policy"). You must read this User Terms and the
              Privacy Policy (which governs the protection and use of personal
              information about User) and access and read all further linked
              information referred to in this User Terms, as such information
              contains further terms and conditions that apply to you as a user
              of THRILLER, such linked information including but not limited to
              the Privacy Policy is hereby incorporated by reference into this
              User Terms. Registration of Membership on the Platform is free,
              however provided services is charged according to schedule, that
              can be timely changed. Changes to the fee policy shall be posted
              on the Platform and such changes shall automatically become
              effective immediately after they are posted on the Platform.
            </p>

            <ul>
              <li>
                <h5>Introduction</h5>
                <p>
                  Thriller Middle East Free Zone LLC is a Company registered
                  under the RAK Free zone, Ras Al Khaimah, United Arab Emirates
                  and providing a virtual Platform for use electronic web-based
                  e-commerce marketplace platforms for providing registered
                  Seller certain services to facilitate the market, sale their
                  products (shoes, sneakers, footwear, and any other items
                  related to footwear) to its customers (Buyer) in tender
                  format. You agree, understand, and acknowledge that our
                  platform is an online platform that enables you to purchase
                  products listed on the website at the price indicated therein
                  at any time from any location. You further agree and
                  acknowledge that THRILLER is only a facilitator and is not and
                  cannot be a party to or control in any manner any transactions
                  on the platform. Accordingly, the contract of sale of products
                  on the platform shall be a strictly bipartite contract between
                  Buyer and the Sellers.
                </p>
              </li>
              <li>
                <h5>Eligibility for Membership</h5>
                <p>
                  The Service is available to register an individual person as a
                  Buyer and a Seller. You cannot be a person barred from
                  providing the Service under any law of your jurisdiction,
                  United Arab Emirates, or other applicable jurisdictions,
                  including the country in which you reside or from where you
                  use the Service. By accepting this Agreement, you represent
                  that you understand and agree to the foregoing. Account only
                  be made with the name of a true and valid official name of
                  User. THRILLER wishes to ensure that its members can form
                  legally binding contracts and further that minors do not
                  purchase unsuitable content. Therefore, membership of the
                  Platform is not available to persons under the age of
                  Twenty-one (21) years. By accepting this Agreement, you
                  represent that you understand and agree to the foregoing. An
                  account only be made with the name of you, and that you will
                  comply with all applicable laws. THRILLER reserves the right
                  to limit or withdraw access to the Platform or the membership
                  of any user or account holder of THRILLER believes that a
                  person is not representing the User. The Platform is not
                  available to User whose membership has been suspended or
                  withdrawn by THRILLER.  No person or User may register as a
                  member of the Website more than once.
                </p>
              </li>
              <li>
                <h5>Your Account and Registration Obligations</h5>
                <p>
                  When you register as a member of the Platform you have been or
                  will be required to provide certain information and register a
                  username and password for use on this Platform. On becoming a
                  member of the Platform, you agree: You are responsible for
                  maintaining the confidentiality of and restricting access to
                  and use of, your account and password, and accept
                  responsibility for all activities that occur under your
                  account and password, if another person uses these methods to
                  access your account, you will be responsible to pay for any
                  Items they order, and we are not responsible for any other
                  losses you suffer. You agree to immediately notify THRILLER of
                  any unauthorized use of your password or account or any other
                  breach of security. In no event will THRILLER be liable for
                  any direct, indirect, or consequential loss or loss of
                  profits, goodwill, or damage whatsoever resulting from the
                  disclosure of your username and/or password. You further
                  acknowledge and agree that the Service is designed for
                  individuals use basis and you should not share your Account
                  and/or password details with others.  You may not use another
                  account at any time, without the express permission of the
                  account holder. You agree to reimburse THRILLER for any
                  improper, unauthorized, or illegal use of your account by you
                  or by any person obtaining access to the Platform, services or
                  otherwise by using your designated username and password,
                  whether or not you authorized such access. You will provide
                  true, accurate, current, and complete information about
                  yourself as prompted by THRILLER's registration form. You will
                  maintain and promptly update the registration data to keep it
                  true, accurate, current, and complete. If you provide any
                  information that is untrue, inaccurate, not current, or
                  incomplete or if THRILLER has reasonable grounds to suspect
                  that such information is untrue, inaccurate, not current or
                  incomplete, or not in accordance with this User Terms, without
                  prejudice to any other rights and remedies of THRILLER under
                  this User Terms or at law, THRILLER has the right to
                  indefinitely suspend, limit or withdraw your access to the
                  Platform and/or your membership of the Platform. THRILLER may
                  (in its sole discretion and at any time), make any inquiries
                  it considers necessary (whether directly or through a third
                  party), and request that you provide it with further
                  information or documentation, including without limitation to
                  verify your identity. Without limiting the foregoing, your
                  information or items detail include your item receipt/ Invoice
                  showing ownership to you. You agree that any sort of wrong and
                  illegal act you may be liable under Cybersecurity laws and
                  other applicable criminal and Civil laws.  You acknowledge and
                  agree that if you do not, THRILLER without liability may
                  limit, suspend, or withdraw your access to the Platform and/or
                  your membership of the Platform. We also reserve the right to
                  cancel unconfirmed/unverified accounts or accounts that have
                  been inactive for a long time. If your use of the Service or
                  other conduct intentionally or unintentionally threatens
                  THRILLER’s ability to provide the Service or other systems,
                  THRILLER shall be entitled to take all reasonable steps to
                  protect the Service and THRILLER’s systems, which may include
                  suspension of your access to the Service. You agree that your
                  Account is non-transferable.
                </p>
              </li>
            </ul>
          </div>

          <div className="question">
            <h5>Access to Your Account and Content</h5>
            <p>
              THRILLER reserves the right to take steps THRILLER believes is
              reasonably necessary or appropriate to enforce and/or verify
              compliance with any part of this Agreement. You acknowledge and
              agree that THRILLER may, without liability to you, access, use,
              preserve and/or disclose your Account information and Content to
              law enforcement authorities, government officials, and/or a third
              party, as THRILLER believes is reasonably necessary or
              appropriate, if legally required to do so or if THRILLER has a
              good faith belief that such access, use, disclosure, or
              preservation is reasonably necessary to: (a) comply with legal
              process or request; (b) enforce this Agreement, including
              investigation of any potential violation thereof; (c) detect,
              prevent or otherwise address security, fraud or technical issues;
              or (d) protect the rights, property or safety of THRILLER, its
              users, a third party, or the public as required or permitted by
              law.
            </p>
          </div>
          <div className="question">
            <h5>License from You</h5>
            <p>
              Except for material we may license to you, THRILLER does not claim
              ownership of the materials and/or content you submit or make
              available on the Service. However, by submitting or posting such
              Content on areas of the Service that are accessible by the public
              or other users with we share such Content, you grant THRILLER a
              worldwide, royalty-free, non-exclusive license to use, distribute,
              reproduce, modify, adapt, publish, translate, publicly perform,
              and publicly display such Content on the Service solely for the
              purpose for which such Content was submitted or made available,
              without any compensation or obligation to you. You agree that any
              Content submitted or posted by you shall be your sole
              responsibility, shall not infringe or violate any intellectual
              property rights of any other party or violate any laws, contribute
              to, or encourage infringing or otherwise unlawful conduct, or
              otherwise be obscene, objectionable, or in poor taste. You license
              that all items posted on the website are genuine and User has
              right intellectually property rights on them, and they are not
              stolen or other’s property. You can only use the services of the
              Website if they do not conflict with or violate the applicable
              laws of your jurisdiction and other related jurisdictions. By
              creating an account, you agree that you may receive communications
              from THRILLER, such as newsletters, special offers, and account
              reminders and updates by Email, SMS, Push Notification, text
              message etc. You also understand that you can remove yourself from
              these email communications by clicking the "Unsubscribe" link in
              the footer of the actual email and will not block email
              subscription.
            </p>
          </div>
          <div className="question">
            <h5>Trade</h5>
            <p>
              A buyer may place a Bid on an item for sale through the platform
              and a Bid matches an Ask, the buyer is obligated to pay for that
              item, it needs to be accepted by us and the Seller before it is
              confirmed. We will send you a notification if your order has been
              accepted. The contract for the supply of any Item you have ordered
              comes into existence when we send the Confirmation Notice. You are
              responsible for paying for all Items ordered using your account,
              and for related delivery charges, and for complying with these
              Terms, even if you have ordered the Item for someone else. All
              Items are subject to availability. In the situations the contract
              is done between buyer and seller under the condition that the
              Items’ authenticity will be approved by Thriller Seller decides
              their own operating hours. That means that the availability of
              Service depends on the seller. <br /> You may select these
              following options on our platform: <br /> Matching: Buyer may
              place bids on listed items on the platform, seller may place an
              item for a fixed or lowest price, and the seller makes a biding
              offer to complete a contract for this item at mentioned fixed or
              lowest price. Buyer may place a bid offering a fixed or highest
              price for a specific item; the buyer makes a binding offer to
              conclude a contract for this item at this fixed or highest price.{" "}
              <br /> Buy now: The seller may also activate the “buy now”
              function. If the buyer uses the “buy now” feature, which will
              attempt to automatically match a buyer with a seller at the lowest
              overall ask price, the contract will be concluded at the moment
              where the buyer clicks on the Buy now button and transaction is
              successfully completed. <br /> Sell now: If the seller uses the
              “sell now” feature, which will attempt to automatically match a
              seller with a buyer at the highest bid, the contract will be
              concluded at the moment where the seller clicks on the “Sell now”
              button and the transaction is successfully completed. <br />{" "}
              Thriller provides a platform to conclude the sale on behalf of
              buyer and seller. Because sellers set prices, they may be higher
              than retail value of the products sold on our platform. Any item
              valuations displayed through the Services are estimates only.
              Thriller does not guarantee that any item will sell. Thriller
              reserves the right to investigate complaints and violations of
              these Terms and, to the extent permitted by applicable law, may
              take any actions we deem appropriate, including suspending a buyer
              or seller account and charging your payment method for costs we
              incur as a result of the violation.
            </p>
          </div>

          <div className="question">
            <h5>Prices and Payment</h5>

            <ul>
              <li>
                <p>
                  · Price of the product will be decided by the Seller. You
                  confirm that Prices can also change at any time at the
                  discretion of the Seller, we or the seller may also charge you
                  a delivery fee. This will be notified to you during the order
                  process before you complete your order. The total price of
                  your order will be set out on the checkout page on Platform,
                  including the prices of Items and Delivery and applicable
                  Service Fees and taxes.
                </p>
              </li>
              <li>
                <p>
                  · All amounts payable by Customer must be received in full
                  prior to commencement of Service. Customer will be responsible
                  for the payment of any present or future sales, VAT, or other
                  similar tax applicable to the services. Taxes will be applied
                  on the Services according to the law of jurisdiction.
                </p>
              </li>
              <li>
                <p>
                  · Payment for all Items and deliveries can be made on our
                  platform by credit or debit card, or other payment method made
                  available by THRILLER. Prices is included VAT. Once your order
                  has been confirmed your credit or debit card will be
                  authorised and the total amount marked for payment (in respect
                  of all payments made by credit or debit cards). Payment is
                  made directly to us acting as agent on behalf of the seller
                  only.
                </p>
              </li>
            </ul>
          </div>

          <div className="question">
            <h5>Transactions Between Buyers and Sellers</h5>

            <p>
              Through the Platform, THRILLER provides electronic web-based
              platforms for exchanging information between buyers and sellers of
              products and services.  THRILLER additionally provides electronic
              web-based transaction platforms for Sellers to place, accept,
              conclude, manage, and fulfil orders for the provision of products
              and services online within the Platform.  However, for any
              Services, THRILLER does not represent either the seller or the
              buyer in specific transactions. THRILLER does not control and is
              not liable or responsible for the quality, safety, lawfulness or
              availability of the products or services offered for sale on the
              Platform, the ability of the sellers to complete a sale or the
              ability of buyers to complete a purchase.
            </p>

            <ul>
              <li>
                <p>
                  . Users are hereby made aware that there may be risks of
                  dealing with people acting under false pretences. THRILLER
                  uses several techniques to verify the accuracy of certain
                  information our paying Users provide us when they register for
                  a paying membership service on the Platform.  However, because
                  user verification on the Internet is difficult, THRILLER
                  cannot and does not confirm each User's purported identity
                  (including, without limitation, paying Sellers). We encourage
                  you to use various means, as well as common sense, to evaluate
                  with whom you are dealing.{" "}
                </p>
              </li>
              <li>
                <p>
                  . Thriller acts as a commercial agent to complete the sale on
                  behalf of each buyer and seller involved in each deal. Because
                  sellers set prices, they may be higher than retail value of
                  the products sold on our platform. Any item valuations
                  displayed through the Services are estimates only. Thriller
                  does not guarantee that any item will sell. Thriller reserves
                  the right to investigate complaints and violations of these
                  Terms and, to the extent permitted by applicable law, may take
                  any actions we deem appropriate, including suspending a buyer
                  or seller account and charging your payment method for costs
                  we incur as a result of the violation.{" "}
                </p>
              </li>
              <li>
                <p>
                  · Buyers and sellers accessing or using the Platform or
                  Services shall assume the risks of conducting any purchase and
                  sale transactions in connection with or through the Platform
                  or Services. Buyer and sellers accessing or using the Site or
                  Services shall also fully assume all risks of liability or
                  harm of any kind arising out of or in connection with any
                  subsequent activity relating to the products or services that
                  are the subject of the transactions on the Platform. Examples
                  of such risks shall include, but are not limited to,
                  mis-representation of products and services, fraudulent
                  schemes, unsatisfactory product quality, failure to meet
                  specifications, defective or dangerous products, unlawful
                  products, delay or default in delivery or payment, cost
                  mis-calculations, breach of warranty, breach of contract,
                  transportation accidents, the risk that the manufacture,
                  importation, export, distribution, offer, display, purchase,
                  sale and/or use of products or services offered or displayed
                  on the Platform may violate or may be asserted to violate
                  Third Party Rights, and the risk that Users may incur costs of
                  defence or other costs in connection with third parties’
                  assertion of Third Party Rights, or in connection with any
                  claims by any party that they are entitled indemnification in
                  relation to the assertion of rights, demands or claims by
                  claimants of Third Party Rights. Examples of such risks also
                  include the risk of claims from consumers, other purchasers,
                  end-users of products or other third parties that they have
                  suffered injuries or harm from their use of the products
                  obtained through the Platform or Services. All of the
                  foregoing risks are referred to as "Transaction Risks".
                  THRILLER is not liable or responsible for any damages, claims,
                  liabilities, costs, harm, inconveniences, business disruptions
                  or expenditures of any kind that may arise a result of or in
                  connection with any Transaction Risks.
                </p>
              </li>
              <li>
                <p>
                  · In the event that any User has a dispute with any party to a
                  transaction, such User agrees to release and indemnify
                  THRILLER (and our agents, affiliates, directors, officers, and
                  employees) from all claims, demands, actions, proceedings,
                  costs, expenses, and damages (including without limitation any
                  actual, special, incidental or consequential damages) arising
                  out of or in connection with such dispute or the transaction.
                </p>
              </li>
              <li>
                <p>
                  · If a buyer receives an item that it believes to be
                  counterfeit, the buyer must notify Thriller in writing within
                  3 days after receiving the item, and we will commence an
                  investigation into the item. The buyer shall cooperate with us
                  in the investigation and final disposition of the item,
                  including providing photographs and other evidence of the
                  item, providing the item to law enforcement, destroying the
                  item, or delivering the item back to us, at our direction. If
                  we elect to have the buyer destroy the item, the buyer shall
                  provide reasonable proof of destruction to us. We will refund
                  all fees and costs paid by the buyer for the item.
                </p>
              </li>
            </ul>
          </div>

          <div className="question">
            <h5>Delivery</h5>
            <p>
              As part of the purchase transaction, the seller will send the item
              to Thriller and Thriller will visually inspect the item and use
              commercially reasonable efforts to confirm it is authentic and
              according to our condition standards. If Thriller determines the
              item is authentic and meets our condition standards, Thriller will
              ship the item to the buyer. If Thriller cannot reasonably confirm
              the authenticity of the item or determines it is not authentic or
              does not meet our condition standards, then we will notify the
              buyer and the seller that the item has not passed authentication
              and will issue a refund to the buyer. Additionally, Thriller has
              the right to reject any item for any reason, including but not
              limited to, authenticity, failure to meet our condition standards,
              or damage of the item. Thriller policy requires sellers to ship
              items within the specified timeframe provided in the sale
              confirmation email after purchase. However, because Thriller
              cannot control the amount of time it takes for the item to reach
              Thriller, we cannot guarantee a specific delivery timeframe for
              any items and therefore, buyer is not permitted to cancel the
              purchase if the item does not ship from the seller within the
              specified timeframe in the sale confirmation email after purchase.
              Once we receive the item from the seller it generally takes 1-2
              business days for us to authenticate the item and ship it to a
              buyer. If a buyer does not receive an item, the buyer shall
              promptly report the issue to Thriller within 2 days of the latest
              estimated delivery date. Thriller has the right, in our sole and
              absolute discretion to refuse to accept returns or other refunds
              and/or to charge restocking fees for returned or abandoned items.
              If a buyer or seller refuses to accept delivery of a package sent
              to his/her address on file, Thriller will consider the property
              abandoned after thirty (30) days and may charge the buyer or
              seller our reasonable expenses incurred due to such refusal to
              accept delivery.
            </p>
          </div>
          <div className="question">
            <h5>Cancellation, Returns and Refund Policy</h5>
            <p>
              Cancelation, Return and Refund of the item purchased by the Buyer
              from the Seller on the Platform will be regulated by the following
              conditions:
            </p>
            <ul>
              <li>
                <p>. Item was defective.</p>
              </li>
              <li>
                <p>. Item was damaged during the Shipping.</p>
              </li>
              <li>
                <p>. Products was / were missing.</p>
              </li>
              <li>
                <p>. Wrong item was sent by the Seller.</p>
              </li>
              <li>
                <p>
                  . Return could also result in refund of money in most of the
                  cases.
                </p>
              </li>
              <li>
                <p>
                  . If the Seller chooses to return applicable on the review
                  page of upon listing an item, the seller agrees to accept the
                  return if the return is made within the allotted time period
                  and with reasonable cause.{" "}
                </p>
              </li>
              <li>
                <p>
                  . We encourage the Buyer to review the listing before making
                  the purchase decision. In case Buyer orders a wrong item,
                  Buyer shall not be entitled to any return/refund.
                </p>
              </li>
              <li>
                <p>
                  . Buyer needs to raise the return request within the return
                  period applicable to the respective product. Once Buyer has
                  raised a return request by contacting Us, Seller while closing
                  the return ticket can select to replace after shipment
                  collection or Refund after shipment collection. Buyer needs to
                  raise the return request within the return period applicable
                  to the respective product. Once Buyer has raised a return
                  request by contacting Us, We will arrange the pickup of the
                  item and, return to the seller, and refund to the buyer.
                </p>
              </li>
              <li>
                <p>
                  . All products listed under a particular category may not have
                  the same returns policy.
                </p>
              </li>
              <li>
                <p>
                  . All requests for refunds will be reviewed on a case by case
                  basis and awarded at THRILLER’s sole discretion.{" "}
                </p>
              </li>
              <li>
                <p>
                  . All approved refunds will be made through the original mode
                  of payment only.
                </p>
              </li>
              <li>
                <p>
                  . Where a bank is not supported for processing refunds, you
                  will be required to share alternate bank account details with
                  us for processing the refund.
                </p>
              </li>
              <li>
                <p>
                  . Refund shall be conditional and shall be with recourse
                  available to THRILLER in case of any misuse by Buyer.
                </p>
              </li>
              <li>
                <p>
                  . We may also request you for additional documents for
                  verification and Refund shall be subject to Buyer complying
                  with Policies.
                </p>
              </li>
              <li>
                <p>
                  . In case of a dispute where the Seller is unable to provide a
                  refund or a replacement, THRILLER will actively work towards
                  reaching a resolution and THRILLER’s decision will be final
                  and obligatory.
                </p>
              </li>
            </ul>
          </div>
          <div className="question">
            <h5>Seller’s obligations</h5>

            <ul>
              <li>
                <p>
                  . By listing an item for sale (each posting, a “New Asking
                  Price”), you are making a binding offer to sell that specific
                  item to a buyer who purchases the item for the Ask price you
                  have specified and to ship the item in accordance with our FAQ
                  as updated from time to time. When a buyer accepts your offer
                  by purchasing your item through our Services, you are
                  contractually and legally bound to deliver that exact item for
                  the specified price. Sellers must ship items via the shipping
                  carrier designated by Thriller within the specified timeframe
                  provided in the sale confirmation email and must obtain a
                  receipt from the shipping carrier to verify shipment of item.
                  Sellers must ship an item sold on our Sites from the country
                  listed as your address on file (e.g., if your address on file
                  is located in Dubai, you cannot use the shipping label
                  provided to you to ship the item from Abu Dhabi). THRILLER
                  will provide you with shipping instructions with such carrier
                  of steps to perform on the seller’s dashboard, after your
                  Asking Price is matched by a buyer. You are obligated to
                  monitor your inventory and ensure all listings are accurate.
                  Once an Offer and an Asking Price are matched, under no
                  circumstances may a seller cancel the listing. Failure to
                  fulfil your orders will result in additional charges to you,
                  including a minimum of AED 50 or an amount up to 15% of the
                  transaction amount, in Thriller’s sole discretion. If a seller
                  fails to deliver items to THRILLER in accordance with these
                  Terms, THRILLER reserves the right to do any or all of the
                  following, in its sole discretion: (i) charge seller’s payment
                  method a minimum of 50AED or an amount up to 20% of the
                  transaction amount, in THRILLERS sole discretion, as a service
                  fee; (ii) remove any or all of seller’s listings from the
                  Services; (iii) cancel any or all of seller’s orders pending
                  through the Services; (iv) withhold any payments due to
                  seller; (v) place limits on seller’s buying and selling
                  privileges; (vi) charge seller’s payment method for costs,
                  expenses and fees incurred by THRILLER as a result of seller’s
                  action or inaction, including charging seller for the cost of
                  a replacement, provided to the buyer, reprinting fees incurred
                  by Thriller, rerouting charges imposed by carriers, and
                  refunds to the buyer; and (vii) temporarily or permanently
                  suspend seller’s account.
                </p>
              </li>
              <li>
                <p>
                  . As a registered Seller, you are allowed to list item for
                  sale on the Platform in accordance with the Policies which are
                  incorporated by way of reference in this Terms of Use. You
                  must be legally able to sell the items you list for sale on
                  our Platform. You must ensure that the listed items do not
                  infringe upon the intellectual property, trade secret or other
                  proprietary rights or rights of publicity or privacy rights of
                  third parties. All listed items must be listed in an
                  appropriate category on the Platform. All listed items must be
                  kept in stock for successful fulfilment of sales.
                </p>
              </li>
              <li>
                <p>
                  . As a registered Seller, you are allowed to list item for
                  sale on the Platform in accordance with the Policies which are
                  incorporated by way of reference in this Terms of Use. You
                  must be legally able to sell the items you list for sale on
                  our Platform. You must ensure that the listed items do not
                  infringe upon the intellectual property, trade secret or other
                  proprietary rights or rights of publicity or privacy rights of
                  third parties. All listed items must be listed in an
                  appropriate category on the Platform. All listed items must be
                  kept in stock for successful fulfilment of sales.
                </p>
              </li>
              <li>
                <p>
                  If a seller provides a counterfeit item or attempts to defraud
                  any buyer Thriller will charge seller’s payment method a
                  minimum of AED 50.00 or an amount up to 20% of the transaction
                  amount as a service fee and shipping charges.
                </p>
              </li>
              <li>
                <p>
                  . You have specifically authorized THRILLER or its service
                  providers to collect, process, facilitate, and remit payments
                  and/or the transaction price electronically. You understand,
                  accept, and agree that the payment facility provided by
                  THRILLER is neither a banking nor financial service, but
                  merely a facilitator providing an electronic, automated online
                  electronic payment facility for receiving payment.
                </p>
              </li>
              <li>
                <p>
                  . Sellers oblige to compliance All consumer rules, laws,
                  bylaws related provisions to their offering product, item, or
                  material according to their local Jurisdiction requirement and
                  if needed keep insurance of any kind damages reimbursement.
                </p>
              </li>
              <li>
                <p>
                  . The listing description of the item must not be misleading
                  and must describe actual condition of the product. If the item
                  description does not match the actual condition of the item,
                  you agree to refund any amounts that you may have received
                  from the Buyer. You agree not to list a single product in
                  multiple quantities across various categories on the Platform.
                  Seller must apply all rules, laws applicable to consumer
                  rights and protection.
                </p>
              </li>
              <li>
                <p>
                  . You will not post or sell any item that is restricted or
                  prohibited by law of United Arab Emirates and any local law in
                  any country or jurisdiction, as user or seller, you are
                  responsible for ensuring that you are not posting an item that
                  is prohibited by law in any jurisdiction, including but not
                  limited illicit drugs, precursors, drug paraphernalia,
                  flammable, explosive and hazardous chemicals, firearms,
                  munitions, weapons, government, law enforcement, military
                  issued items, medical drugs, medical devices, adult, obscene
                  materials, circumvention devices, other equipment used for
                  illicit purposes, illegal services, collections, artifacts,
                  precious metals, human parts, human remains, protected flora,
                  fauna, offensive material, information detrimental to national
                  security, tobacco products, gambling equipment, unauthorised
                  intellectual property rights (IPR) ,replica and counterfeit
                  items, unauthorized copies of intellectual property.
                </p>
              </li>
              <li>
                <p>
                  . Each Seller represents, warrants and agrees that (1) you
                  shall be solely responsible for obtaining all necessary third
                  party licenses and permissions regarding any User Content that
                  you submit, post or display; (2) any User Content that you
                  submit, post or display does not infringe or violate any of
                  the copyright, patent, trademark, trade name, trade secrets or
                  any other personal or proprietary rights of any third party
                  (“Third Party Rights”); (3) you have the right and authority
                  to sell, trade, distribute or export or offer to sell, trade,
                  distribute or export the products or services described in the
                  User Content and such sale, trade, distribution or export or
                  offer does not violate any Third Party Rights and (4) you and
                  your affiliates are not the subject of any trade restrictions,
                  sanctions or other legal restrictions enacted by any country,
                  international organization or jurisdiction.
                </p>
              </li>
              <li>
                <p>
                  . Each Seller further represents, warrants, and agrees that
                  Seller shall/are:
                  <br /> 1. carry on your activities on the Platform in
                  compliance with any applicable laws and regulations;
                  <br />
                  2. conduct your business transactions with other users of the
                  Platform in good faith; carry on your activities in accordance
                  with the Terms and any applicable Additional Agreements;
                  <br />
                  3. not use the Services or Platform to defraud any person or
                  entity (including without limitation sale of stolen items, use
                  of stolen credit/debit cards); not impersonate any person or
                  entity, misrepresent yourself or your affiliation with any
                  person or entity;
                  <br />
                  4. not engage in spamming or phishing;
                  <br />
                  5. not engage in any other unlawful activities (including
                  without limitation those which would constitute a criminal
                  offence, give rise to civil liability, etc) or encourage or
                  abet any unlawful activities;
                  <br />
                  6. not involve any computer viruses or other destructive
                  devices and codes that have the effect of damaging,
                  interfering with, intercepting, or expropriating any software
                  or hardware system, data, or personal information;
                  <br />
                  7. not involve any scheme to undermine the integrity of the
                  data, systems or networks used by THRILLER and/or any user of
                  the Platform or gain unauthorized access to such data, systems
                  or networks; not, and your director(s), officer(s),
                  controlling party/ies, affiliates and legal jurisdiction in
                  which any of the foregoing persons or entities is organized or
                  has operations are not, persons or entities that are subject
                  to any economic or fraud sanctions of any governmental,
                  international or regulatory entities; and
                  <br />
                  8. not engage in any activities that would otherwise create
                  any liability for THRILLER or our affiliates.
                  <br />
                  9. Seller may not use the Platform, Services, or Seller
                  account to engage in activities which are identical or similar
                  to THRILLER e-commerce marketplace business.
                  <br />
                  10. Seller agrees to provide all necessary information,
                  materials, and approval, and render all reasonable assistance
                  and cooperation necessary for THRILLER’s provision of the
                  Services, evaluating whether Seller has breached the Terms
                  and/or handling any complaint against the Seller.  If Seller’s
                  failure to do so results in delay in, or suspension or
                  termination of, the provision of any Service, THRILLER shall
                  not be obliged to extend the relevant service period nor be
                  liable for any loss or damages arising out of or in connection
                  with such delay, suspension, or termination.
                  <br />
                  11. Seller acknowledges and agrees that THRILLER reserves the
                  right to but shall not be required to actively monitor or
                  exercise any editorial control whatsoever over the content of
                  any message or material or information (including User
                  Content) created, obtained or accessible through the Services
                  or Platform. THRILLER does not endorse, verify, or otherwise
                  certify the contents of any comments or other material, or
                  information (including User Content) created, submitted,
                  posted, displayed, or otherwise made by any Seller. Each
                  Seller is solely responsible for the contents of their
                  communications and may be held legally liable or accountable
                  for the content of their comments or other material or
                  information.
                  <br />
                  12. Seller acknowledges and agrees that each Seller is solely
                  responsible for observing applicable laws and regulations in
                  its respective jurisdictions to ensure that all access and use
                  of the Site and Services are in compliance with the same.
                </p>
              </li>
            </ul>
          </div>
          <div className="question">
            <h5>Service Charge </h5>
            <ul>
              <li>
                <p>
                  . In consideration for the Services of our platform provided
                  to Seller will be charged agreed fee on every sale transaction
                  according to separate scheduled and agreed terms, Seller
                  agreed to pay transaction fee, charges with applicable taxes.{" "}
                </p>
              </li>
              <li>
                <p>
                  . You as a Seller agree that you will pay for Delivery charges
                  and Pick up charges for return items.
                </p>
              </li>
              <li>
                <p>
                  . Seller agrees that all accounts, charges, commission, or fee
                  of transaction will be settled according to return policy and
                  after the lapse of return time period and agreed terms and
                  period.
                </p>
              </li>
              <li>
                <p>
                  . THRILLER shall have right to revise the fee, charges, or
                  commission policy any time, amended policy will be posted and
                  declared on the Platform.
                </p>
              </li>
            </ul>
          </div>
          <div className="question">
            <h5>Use of the Platform </h5>
            <p>
              While using the Platform, you will not: post Information or
              content or list items in an inappropriate category or areas on our
              Platform; post any content which insults the UAE state, against
              the UAE laws or Islam, such as any partial or full nudity
              (including simply “beach scene” photographs), fire-arms, drugs or
              alcohol; post items you do not have a right to link to or include;
              post items that are concurrently listed for services on a Website
              other than the Platform; post Information that is (in our sole
              discretion) false, fraudulent, inaccurate, misleading, libellous,
              defamatory, slanderous, unlawfully threatening or would be
              reasonably considered to constitute harassment; post comments,
              questions or answers that are not factual in nature including
              without limitation make any racist comments, use profanity, abuse
              another user, disrespect another's culture or make any other
              derogatory or inappropriate comments; post counterfeit or stolen
              items; post Information or items which infringe any third party's
              intellectual property rights, other proprietary rights or right to
              privacy; post obscene Information or content, including but not
              limited to pornography or any representation which may (in our
              sole discretion) be considered indecent; post Information or
              content which may (in our sole discretion) constitute offensive or
              critical political content or content that is contrary to the
              public interest; post any Information or content or list items
              which may (in our sole discretion) be considered culturally or
              religiously offensive in any way; post any Information or content
              or list items which (in our sole discretion) may not be considered
              to be in compliance with general Islamic Shari’ah law, rules,
              morals, values, ethics and traditions; post Information or content
              threaten national security;  post Information or content or list
              Services which may (in our sole discretion) constitute or be
              considered to promote gambling, terrorism, racism or any kind of
              criminal or illegal act.
            </p>
          </div>
          <div className="question">
            <h5>Changes to Content</h5>
            <p>
              You understand that in order to provide the Service and make your
              Content available thereon, THRILLER may transmit your Content
              across various public networks, in various media, and modify or
              change your Content to comply with technical requirements of
              connecting networks or devices or computers. You further agree
              that THRILLER may limit, suspend, or withdraw your access to the
              Platform and/or a user's membership of the Platform or remove
              hosted content.
            </p>
          </div>
          <div className="question">
            <h5>Amendments to this User Terms</h5>
            <p>
              The THRILLER shall have the right to amend, vary or modify the
              Terms of User, Privacy Commitment of THRILLER Website and these
              Additional Terms of Use governing your use of the Service, without
              giving any prior notice to you and such amendment shall be
              effective immediately upon inclusion/posting of such amendment on
              THRILLER Website. You agree to be bound by the revised Terms.{" "}
              <br />
              You may be required to enter into separate agreement(s), whether
              online or offline, with THRILLER or our affiliate for any Service
              (or features within the Services) (each an “Additional
              Agreement”). If there is any conflict or inconsistency between the
              Terms and an Additional Agreement, the Additional Agreement shall
              take precedence over the Terms only in relation to that Service
              (or feature within the Service) concerned.{" "}
            </p>
          </div>

          <div className="question">
            <h5>Intellectually rights</h5>
            <p>
              The "THRILLER" and related logos, and other words and logos on the
              Platform are either unregistered trademarks or registered
              trademarks of THRILLER and are protected by international
              trademark and other intellectual property rights and laws. All
              other trademarks not owned by THRILLER that appear on the Platform
              are the property of their respective owners, who may or may not be
              affiliated with, connected to, or sponsored by THRILLER.
            </p>
          </div>

          <div className="question">
            <h5>Indemnity and Warranty </h5>
            <p>
              You agree to defend, indemnify, and waive THRILLER and its
              affiliates, directors, Contractors, officers, employees, agents
              and suppliers harmless from any and all claims, demands, actions,
              proceedings, losses, liabilities, damages, costs, expenses
              (including reasonable legal costs and expenses), howsoever
              suffered or incurred due to or arising out of your breach of this
              User Terms, or your violation of any law or the rights of a third
              party.  You acknowledge that you are responsible for all use of
              the Service using your Account and that these Terms apply to any
              and all usage of your Account. You agree to comply with this Terms
              and to defend, indemnify and hold harmless THRILLER from and
              against any and all claims and demands arising from the usage of
              your Account, whether or not such usage is expressly authorized by
              you. <br /> You agree and acknowledge that THRILLER makes no
              warranties or representations about the accuracy or completeness
              of THRILLER Website's content or the content of any Platforms
              linked to THRILLER Website and assumes no liability or
              responsibility for any (i) Errors, mistakes, or inaccuracies of
              content, (ii) Personal injury or property damage, of any nature
              whatsoever, resulting from your access to and use of THRILLER,
              (iii) Any unauthorized access to or use of THRILLER servers and/or
              any and all personal information and/or financial information
              stored therein in any form and/or in any manner, (iv) any
              interruption or cessation of transmission to or from THRILLER
              Website, (iv) Any bugs, viruses, Trojan horses, or the like
              unauthorized tools or software which may be transmitted to or
              through THRILLER Website by any third party, and/or (v) Any errors
              or omissions in any content or for any loss or damage of any kind
              incurred as a result of the use of any content posted, emailed,
              transmitted, or otherwise made available through THRILLER Website.
              THRILLER does not warrant, endorse, guarantee, or assume
              responsibility for any product or service advertised or offered by
              a third party through the THRILLER Website or any associated or
              hyperlinked Website and THRILLER shall not be a party to or in any
              way be responsible or accountable for monitoring any transaction
              between you and third-party.
            </p>
          </div>

          <div className="question">
            <h5>LIMITATION OF LIABILITY</h5>
            <p>
              You expressly understand and agree that, to the maximum extent
              permissible under applicable law, the company shall not be liable
              for any indirect, incidental, special, consequential, or exemplary
              damages, including but not limited to, damages for loss of
              profits, revenue, goodwill, use, data, or other intangible losses
              (even if you have been advised of the possibility of such
              damages). the company provides no guarantees of server uptime or
              applications working properly. in no event will the company’s
              aggregate liability to you for any claims, including under tort,
              contract or otherwise, exceed the amount of fees paid by you to
              the THRILLER. The foregoing limitation of liability shall apply to
              the fullest extent permitted by law in the applicable local and/or
              international jurisdiction.
            </p>
          </div>

          <div className="question">
            <h5>Default of Services</h5>
            <p>
              THRILLER,at FDBC0948 Compass Building, Al Shohada Road, AL Hamra
              Industrial Zone-FZ, Ras Al Khaimah, United Arab Emirates shall not
              be held liable or considered in default of its service agreements,
              implied or express, when the delay of performance is caused by
              circumstances beyond our reasonable control and occurring without
              our fault or negligence, such as but not limited to Failure by
              third party subcontractors, suppliers and/or carriers to provide
              agreed-upon service(s) Problems or failures in accessing on-line
              information sources Problems or failures with phone lines,
              internet access service, web Platform hosting service, or other
              third-party service providers, such as Server failures and
              Software glitches,  Widespread virus problems.
            </p>
          </div>

          <div className="question">
            <h5>Force Majeure</h5>
            <p>
              Under no circumstances shall THRILLER be held liable for any delay
              or failure or disruption of the content or the Services accessed
              or delivered through the Platform or the creation or fulfilment of
              contracts resulting directly or indirectly from acts of nature,
              forces or causes beyond our reasonable control, including without
              limitation, Internet failures, computer, telecommunications or any
              other equipment failures, electrical power failures, strikes,
              labor disputes, riots, insurrections, civil disturbances,
              shortages of labor or materials, fires, flood, storms, explosions,
              acts of God, war, governmental actions, orders of domestic or
              foreign courts or tribunals, or non-performance of third parties
              or any suspension or disruption of transportation or business
              operation (including but not limited to delays or disruption of
              the resumption of work or operation ordered by any government
              agency) in the event of a national or regional spread of epidemic
              or pandemic.
            </p>
          </div>

          <div className="question">
            <h5>Disputes</h5>
            <p>
              If any dispute, claim, controversy, or differences arising out of
              or in connection with or in relation to this User Terms Agreement,
              including any question regarding the formation, existence, scope,
              performance, interpretation, validity or termination of this User
              Terms or clauses, or any question regarding the legal
              relationships established by this User Terms or the consequences
              of its nullity, then the parties shall first attempt amicably to
              settle the Dispute through good faith. The relationship between
              you and THRILLER shall be governed by the laws of the United Arab
              Emirates, In the event that a Dispute has not been settled
              amicably by the relevant parties, the Dispute shall be referred to
              Dubai courts. You and THRILLER agree to submit to the exclusive
              jurisdiction of the dispute will be Dubai Courts, United Arab
              Emirates to resolve any dispute or claim arising from this
              Agreement.
            </p>
          </div>

          <div className="question">
            <h5>Termination</h5>
            <ul>
              <li>
                <h5>Termination by Buyer</h5>
                <p>
                  Buyer may terminate user Account and/or stop using the Service
                  at any time. If a buyer wishes to terminate his account,
                  simply send an email to{" "}
                  <a href="mailto:thefuture@thrillerme.com">
                    {" "}
                    thefuture@thrillerme.com
                  </a>
                  .
                </p>
              </li>
              <li>
                <h5>Termination by Seller</h5>
                <p>
                  Seller can terminate this Agreement by 30 days’ notice. All or
                  any of the Transaction, fee, charges remaining will be
                  completed perfectly by Seller before the termination. All
                  Payment and accounts will be settled by Seller within 30 days
                  of termination of this User agreement. Seller will refund and
                  accept all return items after termination of this agreement.{" "}
                </p>
              </li>
              <li>
                <h5>Termination by THRILLER</h5>
                <p>
                  THRILLER may at any time, under certain circumstances and
                  without prior notice, immediately terminate or suspend all or
                  a portion of your Account and/or access to the Service at any
                  time, under certain circumstances and without, immediately
                  without liability: limit your activity, remove your bids, end
                  your listings, warn other users of your actions, temporarily /
                  indefinitely suspend, limit or withdraw your membership,
                  and/or limit or withdraw your access to the Site, end your
                  listings, warn other users of your actions, temporarily /
                  indefinitely suspend, limit or withdraw your membership to the
                  Site Cause for such termination shall include: <br />
                  1. Violations of this Agreement or any other policies or
                  guidelines that are referenced herein and/or posted on the
                  Service.
                  <br />
                  2. A request by you to cancel or terminate your Account.
                  <br />
                  3. A request and/or order from law enforcement, a judicial
                  body, or other government agency.
                  <br />
                  4. Where provision of the Service to you is or may become
                  unlawful.
                  <br />
                  5. Unexpected technical or security issues or problems.
                  <br />
                  6. Your participation in fraudulent or illegal activities.
                  <br />
                  7. Failure to pay any fees, Charges owed by you in relation to
                  the Service.
                  <br />
                  8. Negative feedback from Customers/ Buyers.
                  <br />
                  Any such termination or suspension shall be made by THRILLER
                  in its sole discretion and THRILLER will not be responsible to
                  you or any third party for any damages that may result or
                  arise out of such termination or suspension of your Account
                  and/or access to the Service. In addition, THRILLER may
                  terminate your Account WITHOUT prior notice. Any such
                  termination or suspension shall be made by THRILLER in its
                  sole discretion and THRILLER will not be responsible to you or
                  any third party for any damages that may result or arise out
                  of such termination or suspension of your Account and/or
                  access to the Service.
                </p>
              </li>
              <li>
                <h5>Effects of Termination</h5>
                <p>
                  Upon termination of your Account, you will lose all access to
                  the Service and any portions thereof, including, but not
                  limited to, your Account, THRILLER ID, email account, and
                  Content. In addition, after a period of time, THRILLER may
                  delete information and data stored in or as a part of your
                  account. Any individual components of the Service that you may
                  have used subject to separate software license agreements will
                  also be terminated in accordance with those license
                  agreements. You further acknowledge and agree that THRILLER
                  shall not be responsible or liable in any way for any damages
                  you incur or allege to have incurred, either directly or
                  indirectly, as a result of your use and/or reliance upon any
                  such Content, advertising, products, or materials on or
                  available from such sites or resources. All or any of the
                  Transaction, fee, and charges remaining will be settled in
                  notice time.{" "}
                </p>
              </li>
            </ul>
          </div>

          <div className="question">
            <h5>Notice</h5>
            <p>
              None of the provisions of this User Terms shall be deemed to
              constitute a partnership or agency between you and THRILLER and
              you shall have no authority to bind THRILLER in any manner
              whatsoever. Except as explicitly stated otherwise, any notices to
              THRILLER from you shall be given by you by THRILLER with a
              physical copy sent to us by email and courier, such notice deemed
              given on confirmation of its receipt to you by THRILLER by return
              email. Any notices to you from THRILLER shall be given by notices
              posted on the Platform or by email to the email address you
              provide to us during the registration process and shall be deemed
              to be received by you 48 hours after any such email is sent.
            </p>
          </div>

          <div className="question">
            <h5>Links to third party</h5>
            <p>
              The Web Platform contains links or other connections to third
              party web Platforms. THRILLER provides these links only as a
              convenience to you and does not endorse, and is not responsible
              for, the contents on such linked Platforms. You accept any terms
              and conditions imposed by that third-party. Further, The THRILLER
              is not responsible for any viruses’ accesses through said
              third-party. If you decide to access linked third-party Web
              Platforms, you do so at your own risk.
            </p>
          </div>

          <div className="question">
            <h5>Transfer of Rights and Obligations</h5>
            <p>
              You hereby grant THRILLER the right to, and irrevocably
              acknowledge and agree that THRILLER may at any time, transfer all
              or any part of its rights, benefits, obligations or liabilities
              (whether express or assumed) under this User Terms to any of its
              affiliates without requiring your further specific agreement. You
              may not at any time, without the prior written consent of
              THRILLER, transfer all or any part of your rights, benefits,
              obligations, or liabilities (whether express or assumed) under
              this User Terms.
            </p>
          </div>

          <div className="question">
            <h5>Severability</h5>
            <p>
              The Web Platform contains links or other connections to third
              party web Platforms. THRILLER provides these links only as a
              convenience to you and does not endorse, and is not responsible
              for, the contents on such linked Platforms. You accept any terms
              and conditions imposed by that third-party. Further, The THRILLER
              is not responsible for any viruses’ accesses through said
              third-party. If you decide to access linked third-party Web
              Platforms, you do so at your own risk.
            </p>
          </div>

          <div className="question">
            <h5>Links to third party</h5>
            <p>
              If any clause of this User Terms shall be deemed invalid, void, or
              for any reason unenforceable, such clause shall be deemed
              severable and shall not affect the validity and enforceability of
              the remaining clauses of this User Terms. This User Terms (as
              amended from time to time in accordance with the terms of this
              User Terms) sets forth the entire understanding and agreement
              between you and THRILLER with respect to the subject matter
              hereof. No person, who is not a party to this User Terms, shall
              have any right to enforce any term of this User Terms. <br />
              If this User Terms are translated into any language other than
              English, whether on the Platform or otherwise, the English text
              shall prevail.
            </p>
            <ul>
              <li>
                <h5>ELECTRONIC CONTRACTING</h5>
                <p>
                  Your use of the Service includes the ability to enter into
                  agreements and/or to make transactions electronically.{" "}
                  <strong>
                    YOU ACKNOWLEDGE THAT YOUR ELECTRONIC SUBMISSIONS CONSTITUTE
                    YOUR AGREEMENT AND INTENT TO BE BOUND BY AND TO PAY FOR SUCH
                    AGREEMENTS AND TRANSACTIONS. YOUR AGREEMENT AND INTENT TO BE
                    BOUND BY ELECTRONIC SUBMISSIONS APPLIES TO ALL RECORDS
                    RELATING TO ALL ELECTRONIC INFORMATION INCLUDES DATA AND
                    INFORMATION IN THE FORM OF TEXT, CODES, SOUND, GRAPHICS,
                    IMAMAGESCOMPTER PROGRAMS OR OTHERWISE AND TRANSACTIONS YOU
                    ENTER INTO ON THIS SERVICE, INCLUDING NOTICES OF
                    CANCELLATION, OTHER POLICIES, CONTRACTS, AND APPLICATIONS.
                  </strong>
                   DISCLAIMER: THRILLER shall not be liable for the loss of any
                  saved/stored data in products that are either repaired or
                  replaced.
                </p>
              </li>
            </ul>
          </div>
          <div className="question">
            <h5>Contact Us</h5>
            <p>
              Please contact us for any questions or comments (including all
              inquiries & Complaints) regarding the Services:{" "}
              <a href="mailTo:thefuture@thrillerme.com">
                {" "}
                thefuture@thrillerme.com
              </a>
            </p>
          </div>
        </div>
      </div>
      {/* <div className="faq-container">
        <h1>Terms & Conditions</h1>
        <div className="question-container">
          <div className="question">
            <h5>AUTHENTICITY</h5>
            <p>
              Failure to complete a sale may include a indefinite suspension of
              your account. This can happen if you sell and ship us a used pair
              of sneakers or streetwear an item that isn’t authentic or doesn’t
              exactly match the item as it is described on StockX in any way if
              you fail to ship the item within the allotted time period StockX
              has no obligation to return items that do not conform to the
              description (including, without limitation, that the item is not
              new and unworn, is not the correct identified size, or does not
              include the original box), or are counterfeit (in which case,
              StockX may turn those items over to the proper authorities) at
              your cost. the seller may choose to return the item to the orginal
              return address (paying the shipping fee) or have us dispose of it.
            </p>
          </div>
          <div className="question">
            <h5>ADJUSTMENTS</h5>
            <p>
              may in our discretion change these Terms (including the FAQs or
              any policy) without notice to you. Changes take effect when we
              post them on our Sites. You should view these Terms often to stay
              informed of any changes that may affect you. YOUR CONTINUED USE OF
              THE SITE AND/OR SERVICES AFTER WE CHANGE THESE TERMS CONSTITUTES
              YOUR ACCEPTANCE OF THE CHANGES. IF YOU DO NOT AGREE TO ANY OF THE
              CHANGES, YOU MUST CANCEL YOUR ACCOUNT AND MUST CEASE USING THE
              SERVICE
            </p>
          </div>
          <div className="question">
            <h5>ACCOUNT REGISTRATION AND SECURITY</h5>
            <p>
              In order to access certain features of the Service and to post any
              Registered User Content on or through the Service, you must
              register to create an account (“Account”) and become a “Registered
              User”. You will be required to provide certain information during
              the registration process, and you agree to provide accurate,
              current, and complete information during the registration process
              and to update such information to keep it accurate, current, and
              complete. We reserve the right to suspend or terminate your
              Account for any reason at our discretion, including if any
              information provided during the registration process or thereafter
              proves to be inaccurate, not current, or incomplete. You are
              responsible for safeguarding your password. You agree not to
              disclose your password to any third party and to take sole
              responsibility for any activities or actions under your Account,
              whether or not you have authorized such activities or actions. You
              will immediately notify us of any unauthorized use of your Account
              by contacting us here. To offer items for sale (asking price)or
              offer to purchase items (offer), you must create an account and
              have a valid paypal or other approved payment method on file with
              us. You agree that we may charge your credit card or other payment
              method for amounts you owe as described in these terms StockX
              cannot and will not be liable for any loss or damage arising from
              your failure to comply with these obligations. If you are under
              18, you may use the Services only with involvement of a parent or
              guardian. We reserve the right to suspend or terminate your
              account in the event that you breach any of these Terms.
            </p>
          </div>
          <div className="question">
            <h5>FEES AND TAXES</h5>
            <p>
              Fees for the Services, including applicable shipping fees, are
              described in our FAQ , as updated from time to time. as a buyer
              you agree to pay any and all local, state, federal, or
              international taxes (including sales taxes) that may be due with
              respect to your purchase transaction You agree to pay 5% VAT. We
              reserve the right to change, or discontinue, temporarily or
              permanently, some or all of such fees (including for promotional
              events), and such changes are effective when we post information
              about the changes through the Service. We may also change our Fee
              Policy at any time and in our sole discretion, and any changes to
              the Fee Policy are effective upon the posting of such changes to
              the Site or upon written notice to any user.
            </p>
          </div>
          <div className="question">
            <h5>SELLERS</h5>
            <p>
              When listing an item for sale and selling an item through the
              Service, you agree to our rules and policies for Sellers described
              in our Selling on Thriller Policy, which can be found at
              www.Thriller.com/selling and our FAQ, which can be found at
              www.Thriller.com/faq, each of which are incorporated by reference
              into these Terms. You further agree that you have the legal
              authority to sell each item that you are listing for sale through
              the Service and that the photos you upload of the item, name of
              the item, and SKU of the item will be accurate to the item you
              ship to us. When a buyer accepts your offer by purchasing your
              item through our Services, you are contractually and legally bound
              to deliver that exact item for the specified price. SELLERS MUST
              SHIP items via the shipping carrier designated by StockX within
              the specified timeframe provided in the sale confirmation email
              and must obtain a receipt from the shipping carrier to verify
              shipment of item. StockX will provide you with a shipping label
              with such carrier after your Ask is matched by a buyer. You are
              obligated to monitor your inventory and ensure all listings are
              accurate. Once a Bid and Ask are matched, under no circumstances
              may a seller cancel the listing. Failure to fulfill your orders
              will result in additional charges to you
            </p>
          </div>
          <div className="question">
            <h5>BUYERS</h5>
            <p>
              When buying an item through the Service, you agree to our rules
              and policies for Buyers described in our FAQ, which can be found
              at www.Thriller.com/faq, as well as our return policy also
              mentioned at www.thrillerme.com/faq. You further agree that you
              are responsible for reading the full item listing before making a
              decision to purchase an item. As a buyer, you are obligated to pay
              for any items you Bid on when your Bid matches a seller’s Ask.
              WHEN YOU PLACE A BID, YOU ARE COMMITTING TO PURCHASE THE ITEM AS
              SOON AS YOUR BID MATCHES A SELLER’S ASK PRICE AND YOU ACKNOWLEDGE
              THAT PAYMENT OF THE ASK PRICE WILL BE TAKEN FROM YOUR PAYMENT
              METHOD. To be an eligible buyer you must have a billing address
              and shipping address within the United Arab
            </p>
          </div>
          <div className="question">
            <h5>ABOUT MARKETPLACE</h5>
            <p>
              Thriller provides a platform for Buyers and Sellers to transact
              with each other. For transactions in which a Seller sells to a
              Buyer through our platform, if you are a Buyer, you acknowledge
              that you are buying items from a third party, not Thriller. We do
              not take title to any items sold by a Seller to a Buyer through
              our platform, and we do not act as a Seller, Buyer, or affiliate
              for a Seller or Buyer with respect to any such transactions. While
              we may help facilitate the resolution of disputes, and may provide
              guarantees stated in our Assurance of Authenticity, we do not
              otherwise guarantee (i) the existence, quality, safety or legality
              of the items advertised; (ii) the truth or accuracy of Sellers’
              listings; (iii) the ability of Sellers to sell items; (iv) the
              ability of Buyers to pay for items; (v) that a Buyer or Seller
              will actually complete a transaction or return an item; or (vi)
              the legal transfer of an item from the Seller to the Buyer.
              Counterfeits, Fraud, and Market Manipulation. StockX takes
              counterfeiting, fraud and market manipulation very seriously. If a
              seller provides a counterfeit item or attempts to defraud any
              buyer or StockX, StockX reserves the right to do any or all of the
              following, in its sole discretion: (i) remove any or all of
              seller’s listings from the Services; (ii) cancel any or all of
              seller’s orders pending through the Services; (iii) withhold any
              payments due to seller; (iv) place limits on seller’s buying and
              selling privileges; (v) charge seller’s credit card for costs,
              expenses and fees incurred by StockX as a result of seller’s
              action or inaction, including rerouting charges imposed by
              carriers, and refunds to the buyer; (vi) ship the item back to the
              seller at the seller’s cost; (vii) provide the counterfeit items
              to law enforcement or destroy the counterfeit items, (viii)
              temporarily or permanently suspend seller’s account If you breach
              any of these Terms, we will have the right to suspend or disable
              your Account or terminate these Terms as they apply to you, at our
              sole discretion and without prior notice to you. We reserve the
              right to revoke your access to and use of the Service and
              Collective Content at any time, with or without cause. When you
              register to join the Service and create an Account, you are free
              to choose any name to identify yourself to other Registered Users.
              However, any complaints to us by Registered Users arising out of
              or in connection with your use of a false name may result, in our
              sole discretion and without prior notice to you, in the suspension
              or disabling of your Account or the termination of these Terms. In
              the event we terminate these Terms for your breach, revoke your
              access to and use of the Service, or terminate or discontinue the
              Service and consequently these Terms, you will remain liable for
              all amounts due under these Terms.
            </p>
          </div>
          <div className="question">
            <h5>INDEMNITY</h5>
            <p>
              You agree to defend, indemnify, and hold GOAT and its officers,
              directors, employees, agents, and representatives harmless from
              and against any claims, liabilities, damages, losses, and
              expenses, including, without limitation, reasonable legal and
              accounting fees, arising out of or in any way connected with your
              access to or use of the Service or Collective Content or your
              violation of these Terms. We reserve the right to assume all or
              any part of the defense of any such claims and negotiations for
              settlement, and you agree to fully cooperate with us in doing so.
            </p>
          </div>
          <div className="question">
            <h5>LIMITATONS OF LIABILITY</h5>
            <p>
              StockX does not provide any guarantee that your items will sell
              and will not provide any compensation for items that do not sell
              through our Services. StockX also does not guarantee how long it
              will take for a listing to appear in the Services after it is
              posted and is not responsible for unsold items resulting from any
              listing delays
            </p>

            <span>You must not:</span>

            <ul>
              <li>
                <p>
                  · use our Services to solicit sales outside of StockX or to
                  contact any user of the Services
                </p>
              </li>
              <li>
                <p>
                  · use our Services if you are not able to form legally binding
                  contracts (for example, if you are under 18 years old), or are
                  temporarily or indefinitely suspended from using our Services;
                </p>
              </li>
              <li>
                <p>
                  · upload or transmit any message, information, data, text,
                  software or images, or other content that is unlawful,
                  immoral, harmful, threatening, abusive, harassing, tortious,
                  defamatory, vulgar, obscene, libelous, or otherwise
                  objectionable, or that may invade another's right of privacy
                  or publicity;
                </p>
              </li>
              <li>
                <p>
                  · engage in abusive treatment of other users of the Services
                  or any StockX employee;
                </p>
              </li>
              <li>
                <p>
                  · create a false identity for the purpose of misleading others
                  or impersonate any person or entity, including, without
                  limitation, any StockX representative, or falsely state or
                  otherwise misrepresent your affiliation with a person or
                  entity;
                </p>
              </li>
              <li>
                <p>
                  · upload or transmit any material that you do not have a right
                  to reproduce, display or transmit under any law or under
                  contractual or fiduciary relationships (such as nondisclosure
                  agreements);
                </p>
              </li>
              <li>
                <p>
                  · delete any author attributions, legal notices or proprietary
                  designations or labels that you upload to any communication
                  feature;
                </p>
              </li>
              <li>
                <p>
                  · use any of the Services’ communication features in a manner
                  that adversely affects the availability of its resources to
                  other users (e.g., excessive shouting, use of all caps, or
                  flooding continuous posting of repetitive text);
                </p>
              </li>
              <li>
                <p>
                  · upload or transmit any unsolicited advertising, promotional
                  materials, “junk mail”, “spam”, “chain letters”, “pyramid
                  schemes” or any other form of solicitation, commercial or
                  otherwise;
                </p>
              </li>
              <li>
                <p>· Violate any applicable local law</p>
              </li>
              <li>
                <p>
                  {" "}
                  upload or transmit any material that infringes any patent,
                  trademark, service mark, trade secret, copyright, or other
                  proprietary rights of any party;· use any robot, spider,
                  scraper, or other automated or manual means to access our
                  Services, or copy any information thereon, for any purpose
                  without our express written permission;
                </p>
              </li>
              <li>
                <p>
                  · take any action that imposes or may impose (to be determined
                  in our sole discretion) an unreasonable or disproportionately
                  large load on our infrastructure or otherwise interferes with
                  the functioning of the Services;
                </p>
              </li>
              <li>
                <p>
                  · attempt to gain any unauthorized access to the Sites or the
                  Services, including computer systems, software, or networks;
                </p>
              </li>
              <li>
                <p>
                  · probe, scan, test the vulnerability of or breach the
                  authentication measures of, the Sites or any related networks
                  or systems;
                </p>
              </li>
              <li>
                <p>
                  · bypass our robot exclusion headers, robots.txt rules or any
                  other measures we may use to prevent or restrict access to our
                  Services;
                </p>
              </li>
              <li>
                <p>
                  · do anything else that we determine, in our sole discretion,
                  misuses the Services or otherwise negatively impacts our
                  marketplace.
                </p>
              </li>
            </ul>
            <p>
              StockX reserves the right to take whatever lawful actions it may
              deem appropriate in response to actual or suspected violations of
              these Terms, including, without limitation, the suspension or
              termination of your access and/or account. StockX may cooperate
              with legal authorities and/or third parties in the investigation
              of any suspected or alleged crime or civil wrong. Except as may be
              expressly limited by the Privacy Policy or applicable law, Company
              reserves the right at all times to disclose any information as
              Company deems necessary to satisfy any applicable law, regulation,
              legal process or governmental request, or to edit, refuse to post
              or to remove any information or materials, in whole or in part, in
              StockX’s sole discretion. You also agree to reimburse StockX for
              any damage, loss, cost or expense StockX incurs (including fees or
              costs of attorneys, accountants, professional advisors, and other
              experts incurred in connection with the defense or settlement of
              the foregoing) because of your use of the Services for any
              unlawful or prohibited purpose.
            </p>
          </div>
          <div className="question">
            <h5>LINKS</h5>
            <p>
              For your convenience, certain third-party websites or resources
              may be provided on the Sites and Services that link to other
              websites or social media platforms which are not under the control
              of StockX (the “Linked Websites”). StockX does not endorse or
              sponsor any Linked Websites and is not responsible for the
              availability, accuracy, content, or any other aspect of the Linked
              Websites. StockX disclaims all liability for such websites, for
              all access to and use thereof, and for use of the links to such
              websites. We also disclaim all liability, and make no
              representations or warranties, with respect to any products or
              services made available, sold, or provided to you by any third
              party. Your use of Linked Websites and any purchases of products
              or services from such Linked Websites are subject to the terms and
              conditions of such other websites. You agree that you will bring
              no suit or claim against StockX arising from or based upon any
              such use of any Linked Websites. Hyperlinks to such Linked
              Websites on the Sites and Services do not imply that: (a) StockX
              is affiliated or associated with any Linked Website; (b) StockX is
              legally authorized to use any trademark, trade name, logo, or
              copyright symbol displayed in connection with or accessible
              through such links; or (c) any Linked Site is authorized to use
              any trademark, trade name, logo, or copyright symbol of StockX.
            </p>
          </div>
          <div className="question">
            <h5>ENTIRE AGREEMENT</h5>
            <p>
              These Terms constitute the entire and exclusive understanding and
              agreement between you and GOAT regarding the Service and
              Collective Content, and these Terms supersede and replace any and
              all prior oral or written understandings or agreements between you
              and GOAT regarding the Service and Collective Content.
            </p>
          </div>
          <div className="question">
            <h5>FEEDBACK</h5>
            <p>
              We welcome and encourage you to provide feedback, comments and
              suggestions for improvements to the Service (“Feedback”). You may
              submit Feedback by contacting us here. You acknowledge and agree
              that all Feedback will be the sole and exclusive property of GOAT
              and you hereby irrevocably assign to GOAT, and agree to
              irrevocably assign to GOAT, all of your right, title, and interest
              in and to all Feedback, including without limitation all worldwide
              patent rights, copyright rights, trade secret rights, and other
              proprietary or intellectual property rights therein. At our
              request and expense, you will execute documents and take such
              further acts as we may reasonably request to assist us to acquire,
              perfect, and maintain GOAT’s intellectual property rights and
              other legal protections for the Feedback.
            </p>
          </div>
        </div>
      </div> */}
      <Links />
    </Fragment>
  );
};
